import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useLocation, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";

function CrearFacturaNoElectronica() {
    const location = useLocation();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);

    // Estados del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [vencimiento, setVencimiento] = useState(new Date().toISOString().split('T')[0]);
    const [profesional, setProfesional] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [tipoPago, setTipoPago] = useState('contado');

    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);

    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');

    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalDescuento, setTotalDescuento] = useState(0);
    const [totalIVA, setTotalIVA] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);

    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);

    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [numeroFacturaCreada, setNumeroFacturaCreada] = useState('');
    const [facturaIdCreada, setFacturaIdCreada] = useState(null);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a crear facturas no electrónicas
        const tienePermiso = userdata.up && userdata.up.includes('facturacion');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Verificar si viene un presupuesto en la URL
        const searchParams = new URLSearchParams(location.search);
        const presupuestoId = searchParams.get('presupuesto');

        if (presupuestoId) {
            cargarPresupuesto(presupuestoId);
        }

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    const getListaPreciosFiltrada = () => {
        if (!clasificacionFiltro) {
            return listaPrecios;
        }

        return listaPrecios.filter(item => {
            return item.clasificacion === clasificacionFiltro;
        });
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };

                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;

                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const baseConDescuento = precioBase - descuento;
            const impuesto = baseConDescuento * (producto.impuesto / 100);

            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += producto.total;
        });

        setTotalBruto(subtotal);
        setTotalDescuento(totalDescuentos);
        setTotalIVA(totalImpuestos);
        setTotalPagar(total);
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;

        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();

            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);
    };

    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => {
        setShowModalExito(false);
        // Opcional: redirigir al listado de facturas
        // history.push('/listado-facturas');
    };

    const cargarPresupuesto = async (presupuestoId) => {
        try {
            // Cargar datos del presupuesto - usar la misma URL que funciona en CrearFactura
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get(`/presupuesto/${presupuestoId}?uid=${userdata.user_id}`);

            if (response.status === 200 && response.data) {
                const presupuesto = response.data;

                // El ID del paciente viene del presupuesto
                const pacienteId = presupuesto.paciente_id;
                setPacienteId(pacienteId);
                setProfesional(presupuesto.users_id.toString());

                // Cargar datos del paciente para mostrar nombre y documento
                const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${presupuesto.paciente_id}`);
                if (pacienteResponse.data && pacienteResponse.data.length > 0) {
                    const paciente = pacienteResponse.data[0];
                    const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                    setNombrePaciente(nombreCompleto);
                    setTipoPaciente(paciente.tipo_documento || 'CC');
                    setDocumentoPaciente(paciente.numero_documento || '');
                }

                // Cargar detalle del presupuesto - usar la misma lógica que CrearFactura
                if (presupuesto.detalle) {
                    const productosPresupuesto = presupuesto.detalle.map(item => ({
                        id: Date.now() + Math.random(),
                        id_listadeprecios: item.id_listadeprecios,
                        codigo: item.lista_precio?.codigo || item.codigo || '',
                        clasificacion: item.lista_precio?.clasificacion || '',
                        descripcion: item.lista_precio?.nombre || item.nombre || item.descripcion || '',
                        cantidad: parseFloat(item.cantidad) || 1,
                        precio: parseFloat(item.precio_unitario) || 0,
                        porcentaje: parseFloat(item.porcentaje) || 0,
                        impuesto: parseFloat(item.impuesto) || 0,
                        total: parseFloat(item.total) || 0
                    }));

                    setProductos(productosPresupuesto);
                    calcularTotales(productosPresupuesto);
                }

                if (presupuesto.observaciones) {
                    setObservaciones(presupuesto.observaciones);
                }
            }
        } catch (error) {
            console.log('Error cargando presupuesto:', error);
            alert('Error al cargar el presupuesto: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!pacienteId || !profesional || productos.length === 0) {
            alert('Por favor complete todos los campos requeridos y agregue al menos un producto');
            return;
        }

        const facturaData = {
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            fecha_emision: fecha,
            fecha_vence: vencimiento,
            forma_pago: metodoPago,
            tipo_pago: tipoPago,
            valor_bruto: totalBruto,
            valor_total: totalPagar,
            observaciones: observaciones,
            detalle: productos.map(p => ({
                id_listadeprecios: p.id_listadeprecios,
                cantidad: p.cantidad,
                precio_unitario: p.precio,
                porcentaje: p.porcentaje,
                impuesto: p.impuesto,
                total: p.total
            }))
        };

        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                }
            };

            const response = await axios.post('/factura-no-electronica', facturaData, config);

            if (response.status === 201) {
                const facturaId = response.data.factura_id;
                const numeroFactura = response.data.numero_factura || 'N/A';

                if (tipoPago === 'credito') {
                    // Crear registro en cuentas por cobrar para facturas a crédito
                    const cuentaData = {
                        factura_id: facturaId,
                        valor_total: totalPagar,
                        valor_pagado: 0,
                        valor_pendiente: totalPagar,
                        fecha_vencimiento: vencimiento
                    };

                    try {
                        await axios.post('/cuentas-por-cobrar', cuentaData, config);
                    } catch (error) {
                        console.log('Error creando cuenta por cobrar:', error);
                    }
                }

                // Guardar datos de la factura creada
                setNumeroFacturaCreada(numeroFactura);
                setFacturaIdCreada(facturaId);

                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalDescuento(0);
                setTotalIVA(0);
                setTotalPagar(0);

                // Mostrar modal de éxito
                setTimeout(() => { handleShowModalExito() }, 500);
            }
        } catch (error) {
            console.log('Error completo:', error);
            alert('Error al guardar la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-facturas">Listado de Facturas</Link></li>
                                        <li className="breadcrumb-item active">Crear Factura No Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Factura No Electrónica</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            <div className="card card-info card-outline">
                                <div className="card card-info-outline">
                                    <div className="card-header">
                                        <h5><b>Información de la Factura</b></h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>

                                            <h5><b>Información del Paciente</b></h5>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <h5><b>Datos de Factura</b></h5>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Fecha del Documento *</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={fecha}
                                                            onChange={(e) => {
                                                                setFecha(e.target.value);
                                                                if (tipoPago === 'contado') {
                                                                    setVencimiento(e.target.value);
                                                                }
                                                            }}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={tipoPago}
                                                            onChange={(e) => {
                                                                setTipoPago(e.target.value);
                                                                if (e.target.value === 'contado') {
                                                                    setVencimiento(fecha);
                                                                }
                                                            }}
                                                            required
                                                        >
                                                            <option value="contado">Contado</option>
                                                            <option value="credito">Crédito</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Vencimiento *</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={vencimiento}
                                                            onChange={(e) => setVencimiento(e.target.value)}
                                                            disabled={tipoPago === 'contado'}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select
                                                            className="form-control"
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Método de Pago *</label>
                                                        <select
                                                            className="form-control"
                                                            value={metodoPago}
                                                            onChange={(e) => setMetodoPago(e.target.value)}
                                                            required
                                                        >
                                                            <option value="10">Efectivo</option>
                                                            <option value="42">Consignación bancaria</option>
                                                            <option value="1">Instrumento no definido</option>
                                                            <option value="20">Cheque</option>
                                                            <option value="30">Transferencia Crédito</option>
                                                            <option value="31">Transferencia Débito</option>
                                                            <option value="45">Transferencia Crédito Bancario</option>
                                                            <option value="47">Transferencia Débito Bancaria</option>
                                                            <option value="48">Tarjeta Crédito</option>
                                                            <option value="49">Tarjeta Débito</option>
                                                            <option value="ZZZ">Acuerdo mutuo</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <select
                                                            className="form-control"
                                                            value={clasificacionFiltro}
                                                            onChange={(e) => setClasificacionFiltro(e.target.value)}
                                                        >
                                                            <option value="">Todas</option>
                                                            {especialidades.map(esp => (
                                                                <option key={esp.id} value={esp.nombre}>{esp.nombre}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                {/* Segunda fila: Selector de servicio + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio a Facturar</label>
                                                        <select
                                                            className="form-control"
                                                            value={productoSeleccionado}
                                                            onChange={(e) => setProductoSeleccionado(e.target.value)}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getListaPreciosFiltrada().map(item => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.codigo} - {item.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {productos.length > 0 && (
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '15%' }}>Clasificación</th>
                                                                <th style={{ width: '25%' }}>Descripción</th>
                                                                <th style={{ width: '8%' }}>Cantidad</th>
                                                                <th style={{ width: '12%' }}>Precio</th>
                                                                <th style={{ width: '8%' }}>Desc. %</th>
                                                                <th style={{ width: '10%' }}>Impuesto</th>
                                                                <th style={{ width: '15%' }}>Total</th>
                                                                <th style={{ width: '7%' }}>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {productos.map(producto => (
                                                                <tr key={producto.id}>
                                                                    <td>{producto.clasificacion || 'N/A'}</td>
                                                                    <td>{producto.descripcion}</td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.cantidad}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                            min="1"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.precio}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.porcentaje}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={producto.impuesto}
                                                                            onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                            step="0.01"
                                                                        />
                                                                    </td>
                                                                    <td>$ {parseFloat(producto.total || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                                    <td style={{ textAlign: 'center' }}>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => eliminarProducto(producto.id)}
                                                                            title="Eliminar"
                                                                        >
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Subtotal:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalBruto || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Descuento:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalDescuento || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>IVA:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalIVA || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <div className="d-flex align-items-center mt-2">
                                                <div style={{ width: '68%' }}></div>
                                                <div style={{ width: '10%', textAlign: 'right', paddingRight: '10px' }}>
                                                    <label className="mb-0"><b>Total:</b></label>
                                                </div>
                                                <div style={{ width: '15%' }}>
                                                    <input type="text" className="form-control text-right" value={`$ ${parseFloat(totalPagar || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} readOnly />
                                                </div>
                                                <div style={{ width: '7%' }}></div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder="Observaciones adicionales"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-success">
                                                    <i className="fas fa-save"></i> Guardar Factura
                                                </button>
                                                <Link to="/listado-facturas" className="btn btn-secondary ml-2">
                                                    <i className="fas fa-times"></i> Cancelar
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Modal de Éxito */}
                <Modal show={showModalExito} onHide={handleCloseModalExito}>
                    <Modal.Header closeButton className="bg-info">
                        <Modal.Title>
                            <i className="fas fa-check-circle"></i> Factura Guardada
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Factura no electrónica guardada exitosamente.</p>
                        <p><strong>Número de Factura:</strong> {numeroFacturaCreada}</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="info" onClick={handleCloseModalExito}>
                            Aceptar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Footer showToast={false} delay={0} />

                {/* Modal de selección de paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Seleccionar Paciente</h4>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => setShowModalPaciente(false)}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Buscar por nombre o documento"
                                            value={busquedaPaciente}
                                            onChange={(e) => setBusquedaPaciente(e.target.value)}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map(paciente => (
                                                    <tr key={paciente.id}>
                                                        <td>
                                                            {`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}
                                                        </td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {getTotalPaginas() > 1 && (
                                        <nav>
                                            <ul className="pagination">
                                                {Array.from({ length: getTotalPaginas() }, (_, i) => (
                                                    <li key={i + 1} className={`page-item ${paginaActual === i + 1 ? 'active' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => setPaginaActual(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    } else {
        return <Loading />;
    }
}

export default CrearFacturaNoElectronica;